import { useEffect, useState } from "react";
import dictionary from "@/shared/MAM/dictionary";

const useMAM = (props) => {
  const [dataMatch, setDataMatch] = useState();
  let intervalMatch;

  const getMatch = async (match, sport) => {    
    try {
      const response = await fetch(`/api/opta/${sport.toLowerCase()}/${match}`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const { data } = await response.json();
      if (data) return data[0];
      return null;
    } catch (error) {
      console.error("Error fetching match data:", error);
      return null;
    }
  };

  const updateNewMatch = async () => {
    try {
      if(!props?.match) return;
      const normalizedSport = props.sport?.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      const data = await getMatch(props.match, normalizedSport);
      
      if (data) {
        const sportKey = normalizedSport.toLowerCase();
        const statusKey = data.status?.toLowerCase();
        if (dictionary[sportKey]?.status[statusKey]?.active === false) {
          clearInterval(intervalMatch);
        }
        setDataMatch(data);
      }
    } catch (error) {
      console.error("Error updating match:", error);
    }
  };

  useEffect(() => {
    updateNewMatch();
    intervalMatch = setInterval(() => {
      updateNewMatch();
    }, 30000);
    return () => {
      clearInterval(intervalMatch);
    };
  }, [props.match, props.sport]);
  
  return {
    dataMatch
  }
}

export default useMAM;